// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2pgPf","checkboxCol":"Table_checkboxCol__37S3a","emailCol":"Table_emailCol__L0HWF","actionCol":"Table_actionCol__3I75S"};